import React from "react";

import { Switch, Route } from "react-router-dom";

import DailyReport from "./_dailyReport/DailyReport";
import GeneralReport from "./_generalReport/GeneralReport";
import AccountsReport from "./_accountsReport/AccountsReport";

const Routes = (props) => {
  const basePath = "/mis";

  return (
    <Switch>
      <Route
        path={`${basePath}/finance/dashboard/daily`}
        render={() => <DailyReport />}
      />
      <Route
        path={`${basePath}/finance/dashboard/general`}
        render={() => <GeneralReport {...props} />}
      />

      <Route
        path={`${basePath}/finance/dashboard/accountReports`}
        render={() => <AccountsReport {...props} />}
      />
    </Switch>
  );
};

export default Routes;
